import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class FormRenderer extends Component {
  static contextTypes = {
    values: PropTypes.object
  };

  render() {
    const { content } = this.props;

    return content(this.context.values);
  }
}



// WEBPACK FOOTER //
// ./src/components/common/form-renderer.js